module.exports = __webpack_public_path__ + "static/Early_Access-bd90860ffb9755ce1638c3cff3c249e2.png";